export default {
  disabled_oa_caterers: [
    22926,
    26466,
    28322,
    8350,
    28323,
    13731,
    19540,
    4280,
    22033,
    14331,
    26545,
    25665,
    22889,
    7722,
    10249,
    26562,
    28419,
    26549,
    1525,
    1510,
    7726,
    27395,
    2417,
    26573,
    22652,
    16971,
    25450,
    6426,
    7699,
    5337,
    21920,
    14920,
    26461,
    3552,
  ]
}
